import React, { useLayoutEffect, useEffect, useState } from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { HeaderBackButton } from '@react-navigation/stack';
import { MainColors, PieChartColors } from '../../constants/Colors';
import FontSizes from '../../constants/FontSizes';
import PieChart from './components/PieChart';
import VotesList from './components/VotesList';
import { useIsFocused } from '@react-navigation/native';
import { MaterialCommunityIcons, FontAwesome5 } from '@expo/vector-icons';
import BallotItemDetailsModal from './components/BallotItemDetailsModal';
import useFetch from '../../utils/useFetch';
import LoadingIndicator from '../../components/ActivityIndicator';

const BallotResultsRundownScreen = ({ navigation, route }) => {
    const isFocused = useIsFocused();
    const { ballotId } = route.params;
    const [ballot, setBallot] = useState();
    const [isBallotItemDetailsModalOpen, setIsBallotItemDetailsModalOpen] = useState(false);
    const [selectedBallotItemInfo, setSelectedBallotItemInfo] = useState([]);
    const { get, isLoading } = useFetch();

    useEffect(() => {
        async function getBallotRundown() {
            const response = await get(`/api/ballots/${ballotId}`);
            setBallot(response);
        }

        getBallotRundown();
    }, [isFocused]);

    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: () => (
                <HeaderBackButton
                    onPress={() => { navigation.goBack() }}
                    label="Results"
                    tintColor="#fff"
                />
            )
        });
    }, [navigation]);

    const onBallotItemInfoButtonPressedHandler = (ballotItem) => {
        setSelectedBallotItemInfo(ballotItem);
        setIsBallotItemDetailsModalOpen(true);
    }

    return (
        <View style={styles.screen}>
            <LoadingIndicator isLoading={isLoading}>
                {ballot ? (
                    <>
                        <View style={styles.ballotTitleContainer}>
                            <Text style={styles.title}>{ballot.title}</Text>
                        </View>
                        <ScrollView style={{ paddingHorizontal: 20 }}>
                            {ballot.ballotItems.map(bi => (
                                <View key={bi.ballotItemId} style={{ marginBottom: 20 }}>
                                    <View style={styles.ballotItemTitleContainer}>
                                        <Text style={styles.ballotItemTitle}>{bi.ballotItemTitle}</Text>
                                        <TouchableOpacity style={{ paddingHorizontal: 4 }}
                                            onPress={() => onBallotItemInfoButtonPressedHandler(bi)}>
                                            <MaterialCommunityIcons name="information-outline"
                                                size={16} color={MainColors.primary} />
                                        </TouchableOpacity>
                                    </View>

                                    <View style={styles.statusContainer}>
                                        {bi.ballotItemStatus === 'Winner' ? (
                                            <View style={{ flexDirection: 'row' }}>
                                                <FontAwesome5 style={{ marginRight: 5 }} name="award" size={20} color={MainColors.primary} />
                                                <Text style={styles.statusText}>The Winner is {bi.winningChoice.choiceTitle}!</Text>
                                            </View>
                                        ) : bi.ballotItemStatus === 'Tie' ? (
                                            <Text style={styles.statusText}>No Winner - Tie</Text>
                                        ) : bi.ballotItemStatus === 'Inconclusive' ? (
                                            <Text style={styles.statusText}>Inconclusive - {bi.ballotItemStatusReason}</Text>
                                        ) : (null)}
                                    </View>

                                    <View style={styles.pieChartContainer}>
                                        <PieChart percents={bi.choices}
                                            openInitially={bi.ballotItemStatus === "Winner"}
                                        />
                                    </View>

                                    <VotesList
                                        ballotItemId={bi.ballotItemId}
                                        choices={bi.choices}
                                        choiceColor={bi.choices.forEach((choice, index) => choice.choiceColor = PieChartColors[index])}
                                    />
                                </View>
                            ))}
                        </ScrollView>
                    </>
                ) : (null)}

                <BallotItemDetailsModal
                    visible={isBallotItemDetailsModalOpen}
                    onModalBackgroundPressed={() => { setIsBallotItemDetailsModalOpen(false) }}
                    onCloseButtonPressed={() => { setIsBallotItemDetailsModalOpen(false) }}
                    infoData={selectedBallotItemInfo}
                    title={selectedBallotItemInfo.ballotItemTitle}
                    description={selectedBallotItemInfo.ballotItemDescription}
                    choices={selectedBallotItemInfo.choices}
                />
            </LoadingIndicator>
        </View>
    )
}

export const screenOptions = () => {
    return {
        headerTitle: 'Rundown',
        headerLeft: null
    }
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
    },
    ballotTitleContainer: {
        backgroundColor: '#0074a6',
        padding: 20,
    },
    title: {
        textAlign: 'center',
        fontSize: FontSizes.large,
        fontWeight: '600',
        letterSpacing: 0.5,
        lineHeight: 24,
        color: '#fff',
    },
    ballotTitle: {
        fontSize: FontSizes.medium,
        fontWeight: '700',
        color: MainColors.darkGray
    },
    ballotItemTitleContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        marginHorizontal: 10,
        marginVertical: 20,
    },
    ballotItemTitle: {
        fontSize: FontSizes.medium,
        fontWeight: '600',
        color: MainColors.darkGray,
        letterSpacing: 0.5,
        textAlign: 'center'
    },
    pieChartContainer: {
        alignItems: 'center',
        marginVertical: 10
    },
    statusContainer: {
        alignItems: 'center',
    },
    statusText: {
        color: MainColors.mediumGray,
        fontSize: FontSizes.medium,
        letterSpacing: 0.5,
        fontWeight: '500',
        marginBottom: 5
    }
});

export default BallotResultsRundownScreen;